import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxTerminatedIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      width="16.087"
      height="16.087"
      transform="matrix(0.866025 -0.5 2.20305e-08 1 11.9062 21.5027)"
      fill="#3B3184"
    />
    <mask
      id="mask0_15925_184841"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="25"
      y="13"
      width="15"
      height="25"
    >
      <rect
        width="16.087"
        height="16.087"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 25.8379 13.4592)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_15925_184841)">
      <rect
        width="16.087"
        height="16.087"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 25.8379 13.4592)"
        fill="#3B3184"
      />
      <ellipse cx="30.6132" cy="18.0556" rx="9.15619" ry="15.5124" fill="#4B3DB2" />
    </g>
    <mask
      id="mask1_15925_184841"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="23"
      y="15"
      width="15"
      height="23"
    >
      <rect
        width="15.7642"
        height="14.7533"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 23.1758 15.3953)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask1_15925_184841)">
      <rect
        width="15.7642"
        height="14.7533"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 23.1758 15.3953)"
        fill="#F2F2F2"
      />
      <ellipse cx="25.4999" cy="15.6574" rx="9.15619" ry="14.2263" fill="white" />
    </g>
    <mask
      id="mask2_15925_184841"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="20"
      y="17"
      width="15"
      height="23"
    >
      <rect
        width="15.7642"
        height="14.7533"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 20.4033 17.4932)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask2_15925_184841)">
      <rect
        width="15.7642"
        height="14.7533"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 20.4033 17.4932)"
        fill="#F2F2F2"
      />
      <ellipse cx="21.0624" cy="17.4931" rx="9.15619" ry="14.2263" fill="white" />
    </g>
    <mask
      id="mask3_15925_184841"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="17"
      y="18"
      width="15"
      height="23"
    >
      <rect
        width="15.7642"
        height="14.7533"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 17.7539 18.8188)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask3_15925_184841)">
      <rect
        width="15.7642"
        height="14.7533"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 17.7539 18.8188)"
        fill="#F2F2F2"
      />
      <ellipse cx="16.8193" cy="20.6289" rx="9.15619" ry="14.2263" fill="white" />
    </g>
    <mask
      id="mask4_15925_184841"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="11"
      y="21"
      width="15"
      height="25"
    >
      <rect
        width="16.087"
        height="16.087"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 11.9062 21.5027)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask4_15925_184841)">
      <rect
        width="16.087"
        height="16.087"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 11.9062 21.5027)"
        fill="#4B3DB2"
      />
      <ellipse cx="16.9199" cy="23.3542" rx="9.15619" ry="15.5124" fill="#6450F7" />
    </g>
    <rect
      width="16.087"
      height="16.087"
      transform="matrix(0.866025 -0.5 2.20305e-08 1 25.8379 29.5461)"
      fill="#3B3184"
    />
    <path d="M25.8232 29.5386L39.7576 21.4936L48.3912 22.7328L34.4569 30.7778L25.8232 29.5386Z" fill="#6450F7" />
    <path d="M11.9061 21.5026L25.8404 13.4576L23.6013 5.41262L9.66697 13.4576L11.9061 21.5026Z" fill="#4B3DB2" />
    <path d="M39.7689 21.5028L25.8413 13.4578L30.5438 6.40246L44.4714 14.4475L39.7689 21.5028Z" fill="#D9D9D9" />
    <path d="M39.7679 21.5028L25.8404 13.4578L30.5428 6.40246L44.4704 14.4475L39.7679 21.5028Z" fill="#6450F7" />
    <path d="M25.8384 29.5585L11.9109 21.5135L7.80045 15.3953L21.728 23.4403L25.8384 29.5585Z" fill="#4B3DB2" />
  </svg>
)
